'use client';

import { useEffect, useState } from 'react';
import PageLoader from '@/components/common/PageLoader';

interface PageLoaderWrapperProps {
  children: React.ReactNode;
}

export default function PageLoaderWrapper({ children }: PageLoaderWrapperProps) {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simple loader with minimal delay - Next.js Image component handles image optimization
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <>
      <PageLoader isLoading={isLoading} />
      {children}
    </>
  );
}